/** Ids travel in the query string, so one request names at most this many. */
export const IDS_PER_REQUEST = 200

/** Runs fn once per chunk of ids small enough for a single request. */
export async function forEachIdChunk(
  ids: string[],
  fn: (chunk: string[]) => Promise<void>
): Promise<void> {
  for (let from = 0; from < ids.length; from += IDS_PER_REQUEST) {
    await fn(ids.slice(from, from + IDS_PER_REQUEST))
  }
}
